<template>
  <div class="container py-4 mt-8">
    <h1 class="font-bitter text-3xl font-bold mb-8">
      The RSC Submissions system is currently unavailable for scheduled maintenance
    </h1>
    <p class="mb-4">
      RSC Submissions is expected to be available again on 3rd June at 12:00 BST.
    </p>
    <p class="mb-4">
      Submissions can still be made via ScholarOne.
    </p>
    <p>
      If you have an urgent enquiry, please contact
      <a
        href="mailto:manuscriptsupport@rsc.org"
        class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      >manuscriptsupport@rsc.org</a
      >.
    </p>
  </div>
</template>
<script setup lang="ts">
</script>
